import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { SpesaLegale } from "../../../models/tipologiche/spesa-legale";
import { SpeseLegaliFormAddComponent } from "../spese-legali-update/spese-legali-form-add.component";


declare var closeModal: any;
declare var openModal: any;
declare var $: any;

@Component({
    selector: 'div [spese-legali-add]',
    templateUrl: 'spese-legali-add.component.html',
    host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class SpeseLegaliAddComponent {
  @Input() tipoPetitium: string;
  @Output() onReturn: EventEmitter<SpesaLegale> = new EventEmitter<SpesaLegale>();
  @ViewChild('formAddSpeseLegali') modaleSpeseLegali: SpeseLegaliFormAddComponent;

  inizializza(tipoPetitium: string) {
    this.tipoPetitium = tipoPetitium;
    this.modaleSpeseLegali.inizializza(tipoPetitium);
    openModal('modalmodaggiungi');
  }

  createForm() {
    this.modaleSpeseLegali.createForm(this.tipoPetitium);
  }

  manageModal(spesaLegale: SpesaLegale) {
      this.createForm();
      closeModal('modalmodaggiungi');
      this.onReturn.emit(spesaLegale);
  }

  newSpesa(spesaLegale: SpesaLegale) {
      this.manageModal(spesaLegale);
  }
}
